import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";
import { requireExhaustive } from "../../shared/src/util";

export const CaseIlaOrDisclaimerChoice = union([
    literal("unknown"),
    literal("none"),
    literal("ila"),
    literal("disclaimer"),
]);
export type TCaseIlaOrDisclaimerChoice = TTypeOfCodec<typeof CaseIlaOrDisclaimerChoice>;

const CaseIlaOrDisclaimerChoiceDisplayName = union([
    literal("Unknown"),
    literal("Not required"),
    literal("Independent legal advice"),
    literal("Signed disclaimer"),
]);
type TCaseIlaOrDisclaimerChoiceDisplayName = TTypeOfCodec<typeof CaseIlaOrDisclaimerChoiceDisplayName>;

export const CaseIlaOrDisclaimerChoice_DisplayName = (choice: TCaseIlaOrDisclaimerChoice): TCaseIlaOrDisclaimerChoiceDisplayName =>
    choice === "unknown" ? "Unknown"
    : choice === "none" ? "Not required"
    : choice === "ila" ? "Independent legal advice"
    : choice === "disclaimer" ? "Signed disclaimer"
    : requireExhaustive(choice);
